import { supabase } from '../supabase';

export interface Currency {
  id: number;
  name: string;
  value: string;
  long_name: string;
}

export const getCurrencies = async (): Promise<Currency[]> => {
  try {
    const { data, error } = await supabase
      .from('currencies')
      .select('*')
      .order('name', { ascending: true });

    if (error) {
      throw new Error(error.message);
    }

    return data as Currency[];
  } catch (error) {
    console.error('Error fetching currencies:', error);
    throw error;
  }
};

export async function createCurrency(
  currency: Omit<Currency, 'id'>
): Promise<Currency | null> {
  const { data, error } = await supabase
    .from('currencies')
    .insert([currency])
    .select()
    .single();

  if (error) {
    console.error('Error creating currency:', error);
    return null;
  }

  return data;
}

export async function updateCurrency(
  id: number,
  currency: Partial<Currency>
): Promise<Currency | null> {
  const { data, error } = await supabase
    .from('currencies')
    .update(currency)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    console.error('Error updating currency:', error);
    return null;
  }

  return data;
}

export async function deleteCurrency(id: number): Promise<boolean> {
  const { error } = await supabase.from('currencies').delete().eq('id', id);

  if (error) {
    console.error('Error deleting currency:', error);
    return false;
  }

  return true;
}
